import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { AlertTabKey, AlertTabKeySchema } from '../../-constants';
import type { DormantUserItem } from './-query/type';
export const DormancyDetailTabKey = {
  ALERT: 'alert',
  EXCLUDED: 'excluded',
  SUSPEND_CANDIDATE: 'suspend_candidate'
} as const;
export type DormancyDetailTabKey = (typeof DormancyDetailTabKey)[keyof typeof DormancyDetailTabKey];
export const DormancyDetailTabKeySchema = z.enum(['alert', 'excluded', 'suspend_candidate']);
export const DormancyDetailColumnKey = {
  USER_NAME: 'userName',
  LAST_SIGNED_IN_AT: 'effectiveLastSignedInAt',
  LAST_ACCESSED_AT: 'lastAccessedAt',
  DORMANT_DAYS: 'dormantDays',
  PATTERN: 'dormancyPattern',
  ACTIONS: 'actions'
} as const;
export type DormancyDetailColumnKey = (typeof DormancyDetailColumnKey)[keyof typeof DormancyDetailColumnKey];
export const DormancyDetailSearchSchema = z.object({
  alertTab: AlertTabKeySchema.default(AlertTabKey.DORMANT_IT),
  tab: DormancyDetailTabKeySchema.default(DormancyDetailTabKey.ALERT),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  dormantDaysMin: z.number().optional(),
  dormantDaysMax: z.number().optional(),
  patternFilter: z.enum(['UNUSED', 'LOW_FREQUENCY', 'ON_LEAVE', 'ALUMNI', 'INVITED']).optional()
});
export const PATTERN_I18N_KEYS = {
  ALUMNI: 'alumni',
  INVITED: 'invited',
  ON_LEAVE: 'onLeave',
  LOW_FREQUENCY: 'lowFrequency',
  UNUSED: 'unused'
} as const satisfies Record<DormantUserItem['dormancyPattern'], string>;
export function isPatternKey(value: string): value is keyof typeof PATTERN_I18N_KEYS {
  return Object.hasOwn(PATTERN_I18N_KEYS, value);
}